module.exports = __webpack_public_path__ + "dist/assets/frontier.7d2b26f895dee71107a5ba4afac09dfc.png";